import { render, staticRenderFns } from "./OurLocation.vue?vue&type=template&id=36409c18&scoped=true&"
var script = {}
import style0 from "./OurLocation.vue?vue&type=style&index=0&id=36409c18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36409c18",
  null
  
)

export default component.exports